export const LOGIN_COPY = {
    title: 'Entra in beDashboard',
    subtitle: 'Con l’account BeSuites di chi lavora qui.',
} as const;
